export default __webpack_public_path__ + "static/media/guia-escritorio-dark-1.0659b987.png";